import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { billingLogoUrl } from '../../config/branding';
import { getCurrentUser, login } from '../../services';
import { normalizeSession } from '../../auth/session';

function LoginPage({ onLogin }) {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (field) => (event) => {
    setCredentials((current) => ({
      ...current,
      [field]: event.target.value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage('');
    setLoading(true);

    try {
      const response = await login(credentials);
      let currentSession = normalizeSession(response);

      if (!currentSession) {
        currentSession = normalizeSession(await getCurrentUser());
      }

      if (!currentSession) {
        throw new Error('No se pudo obtener la sesion del usuario.');
      }

      onLogin(currentSession);
      navigate('/', { replace: true });
    } catch (error) {
      setErrorMessage(
        error?.message || 'No se pudo iniciar sesion. Revisa las credenciales.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box className="login-page">
      <Box className="login-brand-panel">
        <img
          src={billingLogoUrl}
          alt="Facturación de Expediciones"
          className="login-brand-logo"
        />
        <Typography className="login-brand-title">
          Facturación de expediciones
        </Typography>
        <Typography className="login-brand-subtitle">
          Accede para preparar y revisar propuestas de facturación.
        </Typography>
      </Box>

      <Card className="login-card">
        <CardContent>
          <Typography className="login-title">Iniciar sesion</Typography>
          <Typography className="login-subtitle">
            Usa tu usuario de Clasol Suite.
          </Typography>

          {errorMessage ? (
            <Alert severity="error" sx={{ mb: 2 }}>
              {errorMessage}
            </Alert>
          ) : null}

          <Box component="form" className="login-form" onSubmit={handleSubmit}>
            <TextField
              label="Usuario"
              value={credentials.username}
              onChange={handleChange('username')}
              autoComplete="username"
              required
              fullWidth
            />
            <TextField
              label="Contrasena"
              type="password"
              value={credentials.password}
              onChange={handleChange('password')}
              autoComplete="current-password"
              required
              fullWidth
            />
            <Button
              className="suite-primary-button"
              type="submit"
              variant="contained"
              disabled={loading}
              fullWidth
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default LoginPage;
